import { Option } from '@spike/model';
import useNonInitialEffect from '@versiondos/hooks';
import { useState } from 'react';
import styles from './ListContent.module.scss';
import ListItem from './ListItem';

interface ListContentProps<T> {
    options: Array<Option<T> & { disabled?: boolean; description?: string }>;
    selectedIds: Array<T>;
    singleSelection?: boolean;
    className?: string;
    onChange?: (selectedIds: Array<T>) => void;
}

export const ListContent = <T,>(props: ListContentProps<T>) => {
    const [selectedIds, setSelectedIds] = useState(props.selectedIds);

    useNonInitialEffect(() => {
        if (
            props.selectedIds.length !== selectedIds.length ||
            !props.selectedIds.every(id => selectedIds.includes(id))
        ) {
            setSelectedIds(props.selectedIds);
        }
    }, [props.selectedIds]);

    useNonInitialEffect(() => {
        props.onChange?.(selectedIds);
    }, [selectedIds]);

    const clickHandler = (id: T, selected: boolean, disabled?: boolean) => {
        if (disabled) {
            return;
        }
        props.singleSelection
            ? setSelectedIds(selected ? [id] : [])
            : setSelectedIds(prev =>
                  selected
                      ? [...prev.filter(selectedId => selectedId !== id), id]
                      : prev.filter(selectedId => selectedId !== id)
              );
    };

    return (
        <div className={styles.container}>
            {props.options.map(option => (
                <ListItem
                    key={String(option.id)}
                    label={option.name}
                    selected={selectedIds.includes(option.id)}
                    disabled={option.disabled}
                    description={option.description}
                    onClick={selected => clickHandler(option.id, selected, option.disabled)}
                />
            ))}
        </div>
    );
};

export default ListContent;
